<template>
  <div class="toast-container">
    <Message
      v-for="toast in toasts"
      :key="toast.id"
      :severity="toast.severity"
      :icon="toast.icon"
      :title="toast.title"
      @close="remove(toast.id)"
    >
      <template v-if="toast.type === 'html'">
        <div v-html="toast.message"></div>
      </template>
      <template v-else="toast.type === 'text'">{{ toast.message }}</template>
    </Message>
  </div>
</template>

<script setup lang="ts">
  import { useToast } from './useToast'
  import Message from '../message/Message.vue'

  const { toasts, remove } = useToast()
</script>

<style scoped>
  .toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 385px;
  }
</style>
